export default "__VITE_ASSET__Df82OOEE__"